import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class Provider {
  async dailyStats() {
    try {
      const  {data}  =  await axios.get(API_URL + '/entities/stats/byday');
      return data.data; 
    } catch(error) {
      if (error.response.status == 429) {
        return { status: "ratelimited", data: {} }
      } else if (error.response.status == 401) {
        return { status: "unauthorized", data: {} }
      } else {
        return { status: "failed", data: {} }
      }
    }
  }

  async typeStats() {
    try {
      const  {data}  =  await axios.get(API_URL + '/entities/stats/type');
      return data.data; 
    } catch(error) {
      if (error.response.status == 429) {
        return { status: "ratelimited", data: {} }
      } else if (error.response.status == 401) {
        return { status: "unauthorized", data: {} }
      } else {
        return { status: "failed", data: {} }
      }
    }
  }

  async providerStats() {
    try {
      const  {data}  =  await axios.get(API_URL + '/entities/stats/provider');
      return data.data; 
    } catch(error) {
      if (error.response.status == 429) {
        return { status: "ratelimited", data: {} }
      } else if (error.response.status == 401) {
        return { status: "unauthorized", data: {} }
      } else {
        return { status: "failed", data: {} }
      }
    }
  }


}

export default new Provider();
